import angular from 'angular'
import './style.scss'
import { BRAND_NAME } from '../../../core/main/controller/environment'
import '../../../core/main/factory/feature'
import Authentication from '../../../main/factory/authentication'

require('../../../module/online_card_tax_invoice/controller.js')

document.write(require('./view.html').default)

angular.module('merchant.application.page.settlement.onlineCardReconciliations', [
  'merchant.application.module.settlement.settlementList',
  'merchant.application.module.settlement.settlementExport',
  'merchant.application.module.onlineCardTaxInvoice'
]).controller('merchant.application.page.settlement.onlineCardReconciliations.controller', [
  '$rootScope', '$scope', '$controller', '$location',
  'merchant.application.main.factory.authentication',
  'core.application.main.factory.feature',
  'merchant.application.main.factory.settlement',
  '$q',
  function ($rootScope, $scope, $controller, $location, Authentication, Feature, Settlement, $q) {
    $controller('merchant.application.page.controller', { $scope: $scope })

    $scope.model.brandName = BRAND_NAME
    $scope.model.channel = 'ONLINE_CARD'
    $scope.model.countryCode = Authentication.countryCode()
    $scope.model.hasChannels = Authentication.hasAnyChannel('IN_STORE_CARD', 'ONLINE', 'IN_STORE', 'IN_STORE_CARD_ONLINE')
    $scope.model.hasCardData = false

    const country = Authentication.countryCode().toUpperCase()
    $scope.showInvoices = country !== 'FR' && country !== 'IT'

    const nonCardLink = {
      text: 'Online API & In-Store Barcode',
      link: 'reconciliations',
      name: ['reconciliations'],
      permissions: 'VIEW_SETTLEMENT_INFO',
      channels: 'ONLINE IN_STORE'
    }

    const cardLink = {
      text: `${BRAND_NAME} Card`,
      link: 'card-reconciliations',
      name: ['card-reconciliations'],
      permissions: 'VIEW_SETTLEMENT_INFO',
      channels: 'IN_STORE_CARD IN_STORE_CARD_ONLINE'
    }

    const onlineCardLink = {
      text: 'Online Card',
      link: 'online-card-reconciliations',
      name: ['online-card-reconciliations'],
      permissions: 'VIEW_SETTLEMENT_INFO',
      channels: 'ONLINE_CARD'
    }

    const historicalCardReconcilliationParams = {
      offset: 0,
      limit: 1,
      orderBy: 'settlementDate',
      ascending: false,
      merchantId: Authentication.merchantId(),
      channel: 'IN_STORE_CARD'
    }

    $scope.redirectOnLackingChannels = function () {
      if (!$scope.model.onlineCardSettlementEnabled) {
        if (Authentication.hasAnyChannel('ONLINE', 'IN_STORE')) {
          $location.path('reconciliations')
        } else if (Authentication.hasAnyChannel('IN_STORE_CARD', 'IN_STORE_CARD_ONLINE') || $scope.model.hasCardData) {
          $location.path('card-reconciliations')
        } else {
          $location.path('/')
        }
      }
    }

    // Returns a promise which resolves true if merchant has historical card settlements data.
    $scope.hasHistoricalCardSettlementsData = function () {
      const deferred = $q.defer()

      Settlement.read(
        historicalCardReconcilliationParams,
        ({ results, totalResults }) => {
          return deferred.resolve(totalResults >= 1)
        },
        () => {
          console.log('Error fetching historical card-reconciliations.')
          return deferred.resolve(false)
        }
      )
      return deferred.promise
    }

    $scope.buildHeaderFromChannels = function () {
      Feature.retrieveFeatureFlagPromise('merchant-instore-card-banking-and-reconciliation', false).then((cardEnabled) => {
        $scope.hasHistoricalCardSettlementsData().then(function (hasCardData) {
          if (hasCardData) {
            $scope.model.hasCardData = true
            cardLink.channels = '' // show card link if they have historical data, even when they don't have the in_store_card channel
          }

          $scope.redirectOnLackingChannels()

          if (cardEnabled && (Authentication.hasAnyChannel('ONLINE', 'IN_STORE', 'IN_STORE_CARD', 'IN_STORE_CARD_ONLINE') || $scope.model.hasCardData)) {
            const nonCardChannels = []
            if (Authentication.hasChannel('ONLINE')) {
              nonCardChannels.push('Online API')
            }
            if (Authentication.hasChannel('IN_STORE')) {
              nonCardChannels.push('In-Store Barcode')
            }
            nonCardLink.text = nonCardChannels.join(' & ') || 'Online API & In-Store Barcode'

            $rootScope.headerMinor = [nonCardLink, cardLink]
          }
          if ($scope.model.onlineCardSettlementEnabled) {
            if (($rootScope.headerMinor.length > 0) && (!$rootScope.headerMinor.some(e => e.name === 'online-card-reconciliations'))) {
              $rootScope.headerMinor.push(onlineCardLink)
            } else if (($rootScope.headerMinor.length <= 0) && Authentication.hasAnyChannel('ONLINE', 'IN_STORE')) {
              const nonCardChannels = []
              Authentication.hasChannel('ONLINE') && nonCardChannels.push('Online API')
              Authentication.hasChannel('IN_STORE') && nonCardChannels.push('In-Store Barcode')

              nonCardLink.text = nonCardChannels.join(' & ') || 'Online API & In-Store Barcode'
              $rootScope.headerMinor = [nonCardLink, onlineCardLink]
            } else if (($rootScope.headerMinor.length <= 0) && (Authentication.hasAnyChannel('IN_STORE_CARD', 'IN_STORE_CARD_ONLINE') || $scope.model.hasCardData)) {
              $rootScope.headerMinor = [cardLink, onlineCardLink]
            } else {
              $rootScope.headerMinor = [onlineCardLink]
            }
            $scope.$apply()
          }
        })
      })
    }

    $scope.showOnlineCardTaxInvoiceModal = function (type) {
      $scope.model.onlineCardTaxInvoice = {
        type: type
      }
      $scope.model.modulesIncludedInModal = ['online-card-tax-invoice.html']
      $scope.model.isModalVisible = true
    }

    // Temporary solution for toggling online card settlement features. Will refactor once ONLINE_CARD channel gets added.
    Settlement.readOnlineCardSettlementEnabled({ merchantId: Authentication.merchantId() }, function (response) {
      $scope.model.onlineCardSettlementEnabled = (response.enabled == 'true')
      $scope.buildHeaderFromChannels()
    }, function () {
      $scope.buildHeaderFromChannels()
    })
  }
])
